/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarInfo } from '../../models/calendar-info';

export interface GetUserCalendarDelegates$Json$Params {
}

export function getUserCalendarDelegates$Json(http: HttpClient, rootUrl: string, params?: GetUserCalendarDelegates$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CalendarInfo>>> {
  const rb = new RequestBuilder(rootUrl, getUserCalendarDelegates$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CalendarInfo>>;
    })
  );
}

getUserCalendarDelegates$Json.PATH = '/api/User/Calendar/delegated';
